<template>
  <div class="panel panel-default">
    <div class="panel-heading">{{ caixaAlta(tabela.nome) }}</div>
    <div class="panel-body panel_info">
      <table class="table table-striped table-hover tabela_info">
        <tbody>
          <tr>
            <td><strong>Procedimentos</strong></td>
            <td>
              <button
                data-test-id="button-exibiralertavalores-1"
                class="btn btn-xs btn-link"
                @click="
                  exibirAlertaValores(
                    'Procedimentos',
                    tabela.procedimentos,
                    ['codigo', 'nome'],
                    ['Código', 'Nome']
                  )
                "
              >
                Ver todos
              </button>
            </td>
          </tr>
          <tr>
            <td><strong>Situação:</strong></td>
            <td>
              <span
                :class="tabela.ativo ? 'text-success' : 'text-danger'"
                style="margin-left: 8px"
              >
                {{ tabela.ativo ? 'Ativo' : 'Cancelado' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="btn-group btn-group-justified" role="group">
        <RouterLink
          data-test-id="link-auto-2"
          :to="'/tabelasProcedimento/cadastro/' + tabela._id"
          role="button"
          class="btn btn-sm btn-default"
        >
          <span class="fa fa-edit" /> Editar
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import { alertaMixin } from '@/mixins/AlertaMixin'
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'TabelasProcediemntoFicha',
  mixins: [alertaMixin],
  props: {
    tabela: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
